// react-router-dom components
import { Link } from "react-router-dom";

// @mui material components
import Card from "@mui/material/Card";

// Soft UI Dashboard PRO React components
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SoftBadge from "components/SoftBadge";

// Soft UI Dashboard PRO React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import DataTable from "examples/Tables/DataTable";
import { useEffect, useState } from "react";
import ApiService from "services/ApiService";
import ToastUtils from "utils/ToastUtils";
import UsersActionCell from "components/CustomCells/UsersActionCell";
import StorageService from "services/StorageService";

function UsersList() {
  const [usersData, setUsersData] = useState([]);
  const accessLevel = StorageService.getAccessLevel();
  const usersColumns = [
    { Header: "ID", accessor: "id", width: "8%" },
    { Header: "ΟΝΟΜΑ", accessor: "firstName" },
    { Header: "ΕΠΩΝΥΜΟ", accessor: "lastName" },
    { Header: "EMAIL", accessor: "email" },
    { Header: "ΤΗΛΕΦΩΝΟ", accessor: "phone" },
    {
      Header: "ΡΟΛΟΣ",
      accessor: "role.name",
      Cell: ({ value }) => {
        if (value === "master")
          return (
            <SoftBadge variant="contained" color="info" size="xs" badgeContent="Admin" container />
          );
        if (value === "Aade")
          return (
            <SoftBadge variant="contained" color="error" size="xs" badgeContent="ΑΑΔΕ" container />
          );
        return (
          <SoftBadge
            variant="contained"
            color="success"
            size="xs"
            badgeContent="ΧΡΗΣΤΗΣ"
            container
          />
        );
      },
    },
    {
      Header: "ΚΑΤΑΣΤΑΣΗ",
      accessor: "disabled",
      Cell: ({ value }) => {
        if (!value)
          return (
            <SoftBadge
              variant="contained"
              color="success"
              size="xs"
              badgeContent="ΕΝΕΡΓΟΣ"
              container
            />
          );
        return (
          <SoftBadge
            variant="contained"
            color="error"
            size="xs"
            badgeContent="ΑΝΕΝΕΡΓΟΣ"
            container
          />
        );
      },
    },
    { Header: "ΠΑΡΑΣΤΑΤΙΚΑ", accessor: "credits" },
    // {
    //   Header: "EMAIL ΕΠΑΛΗΘΕΥΜΕΝΟ",
    //   accessor: "emailVerified",
    //   Cell: ({ value }) =>
    //     value ? (
    //       <SoftBadge variant="contained" color="success" size="xs" badgeContent="ΝΑΙ" container />
    //     ) : (
    //       <SoftBadge variant="contained" color="error" size="xs" badgeContent="ΟΧΙ" container />
    //     ),
    // },
    // {
    //   Header: "ΤΗΛΕΦΩΝΟ ΕΠΑΛΗΘΕΥΜΕΝΟ",
    //   accessor: "phoneVerified",
    //   Cell: ({ value }) =>
    //     value ? (
    //       <SoftBadge variant="contained" color="success" size="xs" badgeContent="ΝΑΙ" container />
    //     ) : (
    //       <SoftBadge variant="contained" color="error" size="xs" badgeContent="ΟΧΙ" container />
    //     ),
    // },
    { Header: "ΕΝΕΡΓΕΙΕΣ", accessor: "actions" },
  ];

  useEffect(() => {
    getUsersData();
  }, []);

  const getUsersData = async () => {
    const response = await ApiService.getData(`/api/v1/users`);
    if (!response) {
      ToastUtils.error("Αδυναμία εύρεσης χρηστών!");
      return;
    }

    const users = response.data.data;

    users.map((el) => {
      el.actions = (
        <UsersActionCell
          id={el.id}
          userName={`${el.firstName} ${el.lastName}`}
          disabled={!el.disabled}
          refreshTable={getUsersData}
          accessLevel={accessLevel}
        />
      );
    });
    setUsersData(users);
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <SoftBox my={3}>
        <Card>
          <SoftBox display="flex" justifyContent="space-between" alignItems="flex-start" p={3}>
            <SoftBox lineHeight={1}>
              <SoftTypography variant="h5" fontWeight="medium">
                Λίστα Χρηστών
              </SoftTypography>
              <SoftTypography variant="button" fontWeight="regular" color="text">
                Η λίστα περιέχει τους χρήστες της εφαρμογής.
              </SoftTypography>
            </SoftBox>
          </SoftBox>
          <DataTable
            table={{ rows: usersData, columns: usersColumns }}
            entriesPerPage={{
              defaultValue: 10,
              entries: [5, 10, 20],
            }}
            canSearch
            isSorted
          />
        </Card>
      </SoftBox>
      <Footer />
    </DashboardLayout>
  );
}

export default UsersList;
